export default __webpack_public_path__ + "static/media/peercoin-logo.ba2a43c4.svg";